import React, { useContext } from "react";
import PropTypes from "prop-types";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";
import * as Tooltip from "react-tooltip";

import "../../../styles/planTag.scss";
import { format } from "date-fns";

const PlanTag = ({ type, size, level, trialEndOn }) => {
  const { getLang } = useContext(AppContext);
  const TranslationPlan = getLang(langComponent.plan);

  const getNameToDisplay = () => {
    if (type === "freelancer") {
      return TranslationPlan("Freelancer");
    }

    if (type === "trial") {
      return TranslationPlan("Trial");
    }

    if (type === "business") {
      return TranslationPlan("Business");
    }

    if (type === "enterprise") {
      return TranslationPlan("Enterprise");
    }
  };

  if (type === "guest") return null;

  const classNames = ["plan-tag"];
  classNames.push(`plan-tag--${type}`);

  return (
    <>
      <div
        className={classNames.join(" ")}
        data-tooltip-id="plan-tag"
        data-tooltip-content={
          trialEndOn
            ? `Your trial ends on ${format(new Date(trialEndOn), "dd MMMM yy")}`
            : null
        }
      >
        {getNameToDisplay()}
      </div>
      <Tooltip.Tooltip id="plan-tag" />
    </>
  );
};

PlanTag.propTypes = {
  /**
   * `small || medium || large`
   */
  size: PropTypes.string,
  type: PropTypes.string,
  level: PropTypes.number,
};

export default PlanTag;
